// Operation pairs (`${resource}/${action}`) excluded from the UI entirely — no
// card, no leaderboard column, and never summed into any group. This is the
// on/off switch for visibility; the label map only controls grouping.
//
// The headline totals are also corrected for these pairs on the FE: the page
// subtracts each hidden pair's count from the backend-provided totals
// (metrics.totalCount / previousTotalCount and each user's `total`) via
// getVisibleTotalCount / getVisiblePreviousTotalCount / getVisibleUserTotal.
// This works because the backend still returns the hidden pairs in
// `operationTypes` / `byOperationType`, so the FE has the counts to remove.
export const PAY_PER_USE_HIDDEN_OPERATIONS: readonly string[] = [
  'SOURCING/CREATE_PRICE_REPORT',
  'AI_TOOL/VEHICLE_DATA_SCAN',
];
